import { ApiUrls } from "../types/enums";
import { DEFAULT_CULTURE, DEFAULT_TERMINAL } from "../shared/constants";

export const abortBetChanges = async ({
  authorizationKey,
  secondsLeft,
  config,
}: AbortBetChangesPayload): Promise<AbortBetChangesResponse> => {
  const response = await fetch(ApiUrls.ABORT_BET_CHANGES, {
    method: "POST",
    headers: {
      brandid: config.brandId,
      channelid: config.channelId,
      terminal: config?.terminal || DEFAULT_TERMINAL,
      language: config?.language || DEFAULT_CULTURE,
      "content-type": "application/json",
      ...(config.userToken
        ? {
            token: config.userToken,
            authorization: `Bearer ${config.userToken}`,
          }
        : {}),
    },
    body: JSON.stringify({
      AuthorizationKey: authorizationKey,
      SecondsLeft: secondsLeft,
    }),
  });

  return response.json();
};
